// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2GrnM","list":"BalanceDue_list__2au9U","listRow":"BalanceDue_listRow__13roI","total":"BalanceDue_total__20vK5"};